export default __webpack_public_path__ + "static/media/team-girl.5d6603c9.png";